const BLACKLIST_ADDRESSES = [
  {
    zip_code: "96010300",
    addresses: [
      "rua dom pedro ii",
      "dom pedro ii",
      "rua dom pedro",
      "dom pedro",
      "rua dom",
      "dom",
      "rua pedro ii",
      "pedro ii"
    ],
    street_number: "662",
    city: "Pelotas"
  },
  {
    zip_code: "90460100",
    addresses: ["av. alegrete", "av alegrete", "alegrete", "avenida alegrete"],
    street_number: "174",
    city: "Porto Alegre"
  },
  {
    zip_code: "74215040",
    addresses: [
      "rua t-28",
      "t-28",
      "rua t28",
      "rua t 28",
      "t28",
      "t 28",
      "rua t-28 setor bueno",
      "t-28 setor bueno",
      "rua t28 setor bueno",
      "rua t 28 setor bueno",
      "t28 setor bueno",
      "t 28 setor bueno"
    ],
    street_number: "1581",
    city: "Goiânia"
  }
];

const isAddressBlackListed = address => {
  return BLACKLIST_ADDRESSES.some(blocked => {
    const sameZipCode = blocked.zip_code === address.zip_code;
    const sameStreetNumber = blocked.street_number === address.street_number;
    const sameStreet = blocked.addresses.includes(
      address.street.trim().toLowerCase()
    );
    const sameCity =
      blocked.city.trim().toLowerCase() ===
      address.district.city.display_name.trim().toLowerCase();

    return sameZipCode && sameStreetNumber && sameStreet && sameCity;
  });
};

export default {
  isAddressBlackListed
};



// WEBPACK FOOTER //
// ./src/utils/helpers/blacklistHelper.js